export default __webpack_public_path__ + "static/media/InstagramLogo.11195e0b.svg";